module.exports = __webpack_public_path__ + "img/radar.82f90fc0.png";